/* ==========================================================================
   MODULE 3A: SUMMARY CARD RENDERER (summaryRenderer.js - PART 1)
   ========================================================================== */
import { clearParentAttendanceFields } from './parentInfo';
import { sendEmailJS } from './successEmail';

export function renderSummaryCard(data, emailJSData) {

  console.log('[Summary UI] Initiating rendering layout scripts...');

  const summaryCard = document.getElementById('registration-summary-card');

  const gcsRegForm = document.getElementById('reg-form');

  const endFormBtn2 = document.getElementById('end-of-form-btn2');

  if (!summaryCard || !gcsRegForm) return;

  // Insert summary card right above the print/reset button panels rows
  if (endFormBtn2) gcsRegForm.insertBefore(summaryCard, endFormBtn2);

  // Hide the form fields rows cleanly
  Array.from(gcsRegForm.children).forEach(child => {
    if (!['registration-summary-card', 'end-of-form-btn2', 'success-email', 'print-timestamp'].includes(child.id)) {
      child.style.setProperty('display', 'none', 'important');
    }
  });

  summaryCard.classList.remove('d-none');
  summaryCard.style.setProperty('display', 'block', 'important');

  // Text string translation maps
  const typeMap = { '1': 'Beginner Student', '2': 'Returning Student', '3': 'Assistant Instructor' };
  const studentTypeSum = typeMap[data.student.studentType] || '';

  // 1. Generate Student List InnerHTML
  const studentList = document.getElementById('summary-student-list');
  if (studentList) {
    studentList.innerHTML = `
      <li class="list-group-item"><strong>Name:</strong> ${data.student.studentFName} ${data.student.studentLName}</li>
      <li class="list-group-item"><strong>Type:</strong> ${studentTypeSum}</li>
      <li class="list-group-item style="font-size: 0.95rem; font-weight: 700; color: #B650B2; text-transform: uppercase; letter-spacing: 0.5px;"><strong>Sessions Attending</strong></li>
      <li class="list-group-item ms-3"><strong>Oct 17 Bull St Library:</strong> ${data.student.session1 === 1 ? 'Yes' : 'No'}</li>
      <li class="list-group-item ms-3"><strong>Oct 24 Bull St Library:</strong> ${data.student.session2 === 1 ? 'Yes' : 'No'}</li>
      <li class="list-group-item ms-3"><strong>Nov 7 SW Chatham Library:</strong> ${data.student.session3 === 1 ? 'Yes' : 'No'}</li>
      <li class="list-group-item ms-3"><strong>Nov 14 SW Chatham Library:</strong> ${data.student.session4 === 1 ? 'Yes' : 'No'}</li>
      <li class="list-group-item"><strong>Grade:</strong> ${data.student.studentGrade}</li>
      <li class="list-group-item"><strong>School:</strong> ${data.student.studentSchool}</li>
      <li class="list-group-item"><strong>Race/Ethnicity:</strong> ${data.student.studentRace}</li>
      <li class="list-group-item"><strong>Gender:</strong> ${data.student.studentGender}</li>
      <li class="list-group-item"><strong>Date of Birth:</strong> ${data.student.studentDOB}</li>
      <li class="list-group-item"><strong>Zip Code:</strong> ${data.student.studentZip}</li>
      <li class="list-group-item"><strong>Bringing Laptop?</strong> ${data.student.studentNeedsLaptop === '1' ? 'No' : 'Yes'}</li>
    `;
  }

  // 2. Generate Parent List InnerHTML
  const parentList = document.getElementById('summary-parent-list');
  if (parentList) {
    parentList.innerHTML = `
      <li class="list-group-item"><strong>Name:</strong> ${data.parentGuardian.parentFName} ${data.parentGuardian.parentLName}</li>
      <li class="list-group-item"><strong>Relationship:</strong> ${data.parentGuardian.parentRelation}</li>
      <li class="list-group-item"><strong>Email:</strong> ${data.parentGuardian.parentEmail}</li>
      <li class="list-group-item"><strong>Phone:</strong> ${data.parentGuardian.parentPhone}</li>
    `;
  }

/* ==========================================================================
   MODULE 3B: SUMMARY CARD RENDERER (summaryRenderer.js - PART 2)
   ========================================================================== */
  // 1. Target all dynamic parent attendance headers and list containers
  const parentAttendHeading = document.getElementById('parentAttendHeading');
  const parentAttendList = document.getElementById('summary-parent-attend-list');
  const parent1List = document.getElementById('summary-parent-1-attend-list');
  const parent2List = document.getElementById('summary-parent-2-attend-list');

  // 2. CORE CONDITION TRACK: If Beginner Student, hide and collapse all parent class structures completely
  if (studentTypeSum === 'Beginner Student') {

    console.log('[Summary UI] Beginner Student track detected. Compressing parental attendance layouts...');
    
    if (parentAttendHeading) parentAttendHeading.style.setProperty('display', 'none', 'important');
    if (parentAttendList) parentAttendList.style.setProperty('display', 'none', 'important');
    if (parent1List) parent1List.style.setProperty('display', 'none', 'important');
    if (parent2List) parent2List.style.setProperty('display', 'none', 'important');

  } else {
    // 3. ALTERNATIVE TRACK: Restore visibility parameters safely for Returning Students / Assistants
    if (parentAttendHeading) {
      parentAttendHeading.classList.remove('d-none');
      parentAttendHeading.style.removeProperty('display');
    }
    
    if (parentAttendList) {
      parentAttendList.style.removeProperty('display');
      parentAttendList.innerHTML = `
          <li class="list-group-item"><strong>Attending Beginner Class?</strong> ${data.parentGuardian.parentAttending ? 'Yes' : 'No'}</li>
      `;
    }

    // Parent 1 Table generation block
    if (parent1List) {
      if (data.parentGuardian.parentAttendance === 'Same Parent' || data.parentGuardian.parentAttendance === 'Two Parents') {
        const p1Dates = data.parentGuardian.parent1SessionDates || '';
        parent1List.style.removeProperty('display');
        parent1List.innerHTML = `
          <div style="font-size: 0.95rem; font-weight: 700; color: #B650B2; text-transform: uppercase; letter-spacing: 0.5px; padding-bottom: 4px; margin-top: 15px; margin-left: 1rem; border-bottom: 1px solid rgba(182,80,178,0.2);">
            Parent/Guardian Attending: ${data.parentGuardian.parentFName} ${data.parentGuardian.parentLName}
          </div>
          <li class="list-group-item ms-3"><strong>Oct 17 Bull St Library:</strong> ${p1Dates.includes('Oct 17') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Oct 24 Bull St Library:</strong> ${p1Dates.includes('Oct 24') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Nov 7 SW Chatham Library:</strong> ${p1Dates.includes('Nov 7') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Nov 14 SW Chatham Library:</strong> ${p1Dates.includes('Nov 14') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Bringing Laptop?</strong> ${data.parentGuardian.parent1NeedsLaptop === '1' ? 'No' : 'Yes'}</li>
        `;
      } else {
        parent1List.style.setProperty('display', 'none', 'important');
      }
    }

    // Parent 2 Table generation block
    if (parent2List) {
      if (data.parentGuardian.parentAttendance === 'Different Parent' || data.parentGuardian.parentAttendance === 'Two Parents') {
        const p2Dates = data.parentGuardian.parent2SessionDates || '';
        parent2List.style.removeProperty('display');
        parent2List.innerHTML = `
          <div style="font-size: 0.95rem; font-weight: 700; color: #B650B2; text-transform: uppercase; letter-spacing: 0.5px; padding-bottom: 4px; margin-top: 15px; margin-left: 1rem; border-bottom: 1px solid rgba(182,80,178,0.2);">
            Parent/Guardian Attending: ${data.parentGuardian.parent2FName} ${data.parentGuardian.parent2LName}
          </div>
          <li class="list-group-item ms-3"><strong>Oct 17 Bull St Library:</strong> ${p2Dates.includes('Oct 17') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Oct 24 Bull St Library:</strong> ${p2Dates.includes('Oct 24') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Nov 7 SW Chatham Library:</strong> ${p2Dates.includes('Nov 7') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Nov 14 SW Chatham Library:</strong> ${p2Dates.includes('Nov 14') ? 'Yes' : 'No'}</li>
          <li class="list-group-item ms-3"><strong>Bringing Laptop?</strong> ${data.parentGuardian.parent2NeedsLaptop === '1' ? 'No' : 'Yes'}</li>
        `;
      } else {
        parent2List.style.setProperty('display', 'none', 'important');
      }
    }
  }

  // Emergency, Medical, and Signature injections lines
  const emergList = document.getElementById('summary-emerg-list');
  if (emergList) {
    emergList.innerHTML = `<li class="list-group-item"><strong>Name &#38; Phone:</strong> ${data.emergencyContact.emergFName} ${data.emergencyContact.emergLName}<br>(${data.emergencyContact.emergPhone})</li>`;
  }

  const medList = document.getElementById('summary-student-med-list');
  if (medList) {
    medList.innerHTML = `
      <li class="list-group-item"><strong>Medical Issues:</strong> ${data.medical.medIssues === '1' ? 'Yes,' : 'No'} ${data.medical.explainMed}</li>
      <li class="list-group-item"><strong>Food Allergies:</strong> ${data.medical.allergies === '1' ? 'Yes,' : 'No'} ${data.medical.explainAllergies}</li>
      <li class="list-group-item pe-xs-2 pe-sm-0"><strong>Preferred Hospital:</strong> ${data.medical.hospital}</li>
    `;
  }

  const consentList = document.getElementById('summary-consent-list');
  if (consentList) {
    consentList.innerHTML = `
      <li class="list-group-item"><strong>Agreed to Policies:</strong> Yes</li>
      <li class="list-group-item"><strong>Electronic Signature:</strong> <span style="font-family: 'Cherry Cream Soda', cursive;">${data.consentAndSignatures.signerName}</span></li>
      <li class="list-group-item"><strong>Payment:</strong> ${data.student.studentType === '1' ? 'Paid $10 Commitment Fee' : 'None required'}</li>
    `;
  }

  // Un-hide print panels control wrappers dynamically
  if (endFormBtn2) endFormBtn2.style.setProperty('display', 'block', 'important');
  if (document.getElementById('success-email')) document.getElementById('success-email').style.setProperty('display', 'block', 'important');
  document.querySelectorAll('#printRegFormButton, #resetRegFormButton').forEach(btn => btn.style.setProperty('display', 'block', 'important'));

  setTimeout(() => {
    summaryCard.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 300);


  sendEmailJS(emailJSData);
 
}

export function handleMasterFormReset() {
  const gcsRegForm = document.getElementById('reg-form');
  if (!gcsRegForm) return;

  localStorage.removeItem('gcs_summary_cache');
  gcsRegForm.style.display = 'block';
  
  Array.from(gcsRegForm.children).forEach(child => child.style.removeProperty('display'));
  document.getElementById('registration-summary-card')?.classList.add('d-none');
  
  gcsRegForm.reset();
  document.querySelector('.needs-validation')?.classList.remove('was-validated');
  clearParentAttendanceFields();
  window.schoolDistrict = null;
  
  const schoolSpan = document.getElementById('schoolDropdownButton')?.querySelector('span');
  if (schoolSpan) schoolSpan.textContent = 'Select...';

  const raceSelect = document.getElementById('raceDropdownButton');
  if (raceSelect) { raceSelect.textContent = 'Select...'; }

  document.querySelectorAll('#payCommitFeeButton, #submitRegFormButton').forEach(btn => {
    btn.disabled = false;
    btn.classList.remove('loading');
  });

  document.getElementById('payCommitFeeButton').querySelector('.button-text').textContent = 'Pay $10 Commitment Fee & Complete Registration';
  
  document.getElementById('submitRegFormButton').querySelector('.button-text').textContent = 'Submit Registration Form';

  document.querySelectorAll('#end-of-form-btn2, #success-email, #printRegFormButton, #resetRegFormButton').forEach(el => el.style.display = 'none');
  document.getElementById('class-title-div')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
